import { Slide } from "@jelly/lesson";
import { task as task04 } from "../../../../../task/course-05/lesson-11/task-04";

const task: Slide = {
  title: `To strengthen the perception of warmth in the response of a hall, the process of acoustic design should strive for:`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
